import * as tslib_1 from "tslib";
import datapoints from './datapoints';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getStore } from 'owa-mail-folder-forest-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { setSearchText } from 'owa-mail-search-store';
import { resetSearchInputState, searchStore } from 'owa-mail-search-store';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import { lazyStartSearch, lazyStartSearchSession, lazySetStaticSearchScope, } from 'owa-mail-search-actions';
import { lazyIsInSearchMode, lazyOnSearchTextChanged, lazyStartSearchSession as lazyStartSearchSessionV2, startSearch, lazyClearSearchBox, SearchScenarioId, } from 'owa-search';
import { lazySetStaticSearchScopeData } from 'owa-mail-search';
/**
 * Select a favorite search node
 * @param searchQuery the search query
 */
export default action('selectFavoriteSearch', datapoints.selectFavoriteSearch)(function selectFavoriteSearch(searchQuery) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var folderForestStore, favoriteSearchNode, clearSearchBox, isInSearchMode, onSearchTextChanged, setStaticSearchScopeData, startSearchSession;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Reset existing search input state
                    resetSearchInputState();
                    folderForestStore = getStore();
                    favoriteSearchNode = getSharedFavoritesStore().favoriteSearches.get(searchQuery);
                    if (!(favoriteSearchNode != folderForestStore.selectedNode)) return [3 /*break*/, 7];
                    // Set the favorite search node as selected in folder forest
                    folderForestStore.selectedNode = {
                        id: favoriteSearchNode.id,
                        type: 3 /* Search */,
                        treeType: 'favorites',
                    };
                    if (!isMailFeatureEnabled('sea-commonSearchBox')) return [3 /*break*/, 6];
                    return [4 /*yield*/, lazyClearSearchBox.import()];
                case 1:
                    clearSearchBox = _a.sent();
                    return [4 /*yield*/, lazyIsInSearchMode.import()];
                case 2:
                    isInSearchMode = _a.sent();
                    return [4 /*yield*/, lazyOnSearchTextChanged.import()];
                case 3:
                    onSearchTextChanged = _a.sent();
                    return [4 /*yield*/, lazySetStaticSearchScopeData.import()];
                case 4:
                    setStaticSearchScopeData = _a.sent();
                    return [4 /*yield*/, lazyStartSearchSessionV2.import()];
                case 5:
                    startSearchSession = _a.sent();
                    // If user isn't in search mode, start a search session.
                    if (!isInSearchMode(SearchScenarioId.Mail)) {
                        startSearchSession('FavoritesSearchNode', false /* shouldStartSearch */, SearchScenarioId.Mail);
                    }
                    // Clear pills and text from search box.
                    clearSearchBox(SearchScenarioId.Mail);
                    // Reset the search scope to the selected node.
                    setStaticSearchScopeData(false /* shouldClear */);
                    // Update search text and start search.
                    onSearchTextChanged(searchQuery, SearchScenarioId.Mail);
                    startSearch('FavoritesSearchNode', SearchScenarioId.Mail, false /* explicitSearch */);
                    return [3 /*break*/, 7];
                case 6:
                    // Start search session if we aren't in a search session already
                    if (!searchStore.searchSessionGuid) {
                        lazyStartSearchSession.importAndExecute();
                    }
                    // Always reset the static search scope
                    lazySetStaticSearchScope(folderForestStore.selectedNode);
                    // Start search
                    setSearchText(searchQuery);
                    lazyStartSearch('FavoritesSearchNode');
                    _a.label = 7;
                case 7:
                    // Trigger mail module RP orchestrator to close immersive RP
                    mailModuleOrchestrator.lazyOnSelectingFolder.importAndExecute();
                    // Clear undo stack
                    undoActions.clearLastUndoableAction();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=selectFavoriteSearch.js.map